import { axiosInstance } from '../api';

export default function(fhirId) {
    return axiosInstance.get(`/fhir/ResearchStudy/$studyDetails?_id=${fhirId}`);
}